/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListVendorsParams,
  PaginatedVendorListOut,
  VendorIn,
  VendorOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listVendorsResponse200 = {
  data: PaginatedVendorListOut
  status: 200
}

export type listVendorsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listVendorsResponseSuccess = (listVendorsResponse200) & {
  headers: Headers;
};
export type listVendorsResponseError = (listVendorsResponse422) & {
  headers: Headers;
};

export type listVendorsResponse = (listVendorsResponseSuccess | listVendorsResponseError)

export const getListVendorsUrl = (params?: ListVendorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vendors?${stringifiedParams}` : `/api/vendors`
}

/**
 * @summary List Vendors
 */
export const listVendors = async (params?: ListVendorsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listVendorsResponse> => {

  return apiFetch<listVendorsResponse>(getListVendorsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorsQueryKey = (params?: ListVendorsParams,) => {
    return [
    `/api/vendors`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVendorsQueryOptions = <TData = Awaited<ReturnType<typeof listVendors>>, TError = HTTPValidationError>(params?: ListVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendors>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendors>>> = ({ signal }) => listVendors(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListVendorsQueryResult = NonNullable<Awaited<ReturnType<typeof listVendors>>>
export type ListVendorsQueryError = HTTPValidationError


export function useListVendors<TData = Awaited<ReturnType<typeof listVendors>>, TError = HTTPValidationError>(
 params: undefined |  ListVendorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVendors>>,
          TError,
          Awaited<ReturnType<typeof listVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVendors<TData = Awaited<ReturnType<typeof listVendors>>, TError = HTTPValidationError>(
 params?: ListVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVendors>>,
          TError,
          Awaited<ReturnType<typeof listVendors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVendors<TData = Awaited<ReturnType<typeof listVendors>>, TError = HTTPValidationError>(
 params?: ListVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendors>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Vendors
 */

export function useListVendors<TData = Awaited<ReturnType<typeof listVendors>>, TError = HTTPValidationError>(
 params?: ListVendorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVendors>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListVendorsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createVendorResponse201 = {
  data: VendorOut
  status: 201
}

export type createVendorResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createVendorResponseSuccess = (createVendorResponse201) & {
  headers: Headers;
};
export type createVendorResponseError = (createVendorResponse422) & {
  headers: Headers;
};

export type createVendorResponse = (createVendorResponseSuccess | createVendorResponseError)

export const getCreateVendorUrl = () => {




  return `/api/vendors`
}

/**
 * @summary Create Vendor
 */
export const createVendor = async (vendorIn: VendorIn, options?: Parameters<typeof apiFetch>[1]): Promise<createVendorResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createVendorResponse>(getCreateVendorUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorIn)
  }
);}





export const getCreateVendorMutationKey = () => ['createVendor'] as const;

export const getCreateVendorMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendor>>, TError,CreateVendorMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVendor>>, TError,CreateVendorMutationVariables, TContext> => {

const mutationKey = getCreateVendorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVendor>>, CreateVendorMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createVendor(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVendorMutationResult = NonNullable<Awaited<ReturnType<typeof createVendor>>>
    export type CreateVendorMutationBody = VendorIn
    export type CreateVendorMutationError = HTTPValidationError
    export type CreateVendorMutationVariables = {data: VendorIn}

    /**
 * @summary Create Vendor
 */
export const useCreateVendor = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVendor>>, TError,CreateVendorMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVendor>>,
        TError,
        CreateVendorMutationVariables,
        TContext
      > => {
      return useMutation(getCreateVendorMutationOptions(options), queryClient);
    }
    export type getVendorResponse200 = {
  data: VendorOut
  status: 200
}

export type getVendorResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getVendorResponseSuccess = (getVendorResponse200) & {
  headers: Headers;
};
export type getVendorResponseError = (getVendorResponse422) & {
  headers: Headers;
};

export type getVendorResponse = (getVendorResponseSuccess | getVendorResponseError)

export const getGetVendorUrl = (recordId: number,) => {




  return `/api/vendors/${recordId}`
}

/**
 * @summary Get Vendor
 */
export const getVendor = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getVendorResponse> => {

  return apiFetch<getVendorResponse>(getGetVendorUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorQueryKey = (recordId: number,) => {
    return [
    `/api/vendors/${recordId}`
    ] as const;
    }


export const getGetVendorQueryOptions = <TData = Awaited<ReturnType<typeof getVendor>>, TError = HTTPValidationError>(recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendor>>> = ({ signal }) => getVendor(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVendorQueryResult = NonNullable<Awaited<ReturnType<typeof getVendor>>>
export type GetVendorQueryError = HTTPValidationError


export function useGetVendor<TData = Awaited<ReturnType<typeof getVendor>>, TError = HTTPValidationError>(
 recordId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendor>>,
          TError,
          Awaited<ReturnType<typeof getVendor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVendor<TData = Awaited<ReturnType<typeof getVendor>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendor>>,
          TError,
          Awaited<ReturnType<typeof getVendor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVendor<TData = Awaited<ReturnType<typeof getVendor>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Vendor
 */

export function useGetVendor<TData = Awaited<ReturnType<typeof getVendor>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVendorQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateVendorResponse200 = {
  data: VendorOut
  status: 200
}

export type updateVendorResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateVendorResponseSuccess = (updateVendorResponse200) & {
  headers: Headers;
};
export type updateVendorResponseError = (updateVendorResponse422) & {
  headers: Headers;
};

export type updateVendorResponse = (updateVendorResponseSuccess | updateVendorResponseError)

export const getUpdateVendorUrl = (recordId: number,) => {




  return `/api/vendors/${recordId}`
}

/**
 * @summary Update Vendor
 */
export const updateVendor = async (recordId: number,
    vendorIn: VendorIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateVendorResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateVendorResponse>(getUpdateVendorUrl(recordId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorIn)
  }
);}





export const getUpdateVendorMutationKey = () => ['updateVendor'] as const;

export const getUpdateVendorMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendor>>, TError,UpdateVendorMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVendor>>, TError,UpdateVendorMutationVariables, TContext> => {

const mutationKey = getUpdateVendorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVendor>>, UpdateVendorMutationVariables> = (props) => {
          const {recordId,data} = props ?? {};

          return  updateVendor(recordId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVendorMutationResult = NonNullable<Awaited<ReturnType<typeof updateVendor>>>
    export type UpdateVendorMutationBody = VendorIn
    export type UpdateVendorMutationError = HTTPValidationError
    export type UpdateVendorMutationVariables = {recordId: number;data: VendorIn}

    /**
 * @summary Update Vendor
 */
export const useUpdateVendor = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVendor>>, TError,UpdateVendorMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVendor>>,
        TError,
        UpdateVendorMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateVendorMutationOptions(options), queryClient);
    }
    export type deleteVendorResponse204 = {
  data: void
  status: 204
}

export type deleteVendorResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteVendorResponseSuccess = (deleteVendorResponse204) & {
  headers: Headers;
};
export type deleteVendorResponseError = (deleteVendorResponse422) & {
  headers: Headers;
};

export type deleteVendorResponse = (deleteVendorResponseSuccess | deleteVendorResponseError)

export const getDeleteVendorUrl = (recordId: number,) => {




  return `/api/vendors/${recordId}`
}

/**
 * @summary Delete Vendor
 */
export const deleteVendor = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteVendorResponse> => {

  return apiFetch<deleteVendorResponse>(getDeleteVendorUrl(recordId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteVendorMutationKey = () => ['deleteVendor'] as const;

export const getDeleteVendorMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVendor>>, TError,DeleteVendorMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVendor>>, TError,DeleteVendorMutationVariables, TContext> => {

const mutationKey = getDeleteVendorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVendor>>, DeleteVendorMutationVariables> = (props) => {
          const {recordId} = props ?? {};

          return  deleteVendor(recordId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVendorMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVendor>>>

    export type DeleteVendorMutationError = HTTPValidationError
    export type DeleteVendorMutationVariables = {recordId: number}

    /**
 * @summary Delete Vendor
 */
export const useDeleteVendor = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVendor>>, TError,DeleteVendorMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVendor>>,
        TError,
        DeleteVendorMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteVendorMutationOptions(options), queryClient);
    }
